// extracted by mini-css-extract-plugin
module.exports = {"attachmentsLayout":"clinical-portal-3__ConsultationAttachments__attachmentsLayout","pdfLink":"clinical-portal-3__ConsultationAttachments__pdfLink"};